import { observer } from "mobx-react-lite";

import { SplitView } from "../ui/SplitView";
import { SongDetail } from "./SongDetail";
import { SongList } from "./SongList";

/** All songs, next to the one that's picked. */
export const SongsScreen = observer(function SongsScreen({ songId }: { songId?: string }) {
    const detail = songId && <SongDetail key={songId} songId={songId} />;

    return <SplitView listLabel="Songs" list={<SongList selectedId={songId} />} detail={detail} />;
});
